module.exports = __webpack_public_path__ + "img/mastercard-logo.181f9983.png";